module.exports = __webpack_public_path__ + "img/BRCA1_Mono.Macro.b4059682.png";